import _objectSpread from "C:\\j\\workspace\\Snap_Blockly_release-staging\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../Loading/Loading.js';
import styles from './styles.js'; // one of the reasons why we use a separate prop for passing ref instead of using forwardref

function MonacoContainer(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      isEditorReady = _ref2.isEditorReady,
      loading = _ref2.loading,
      _ref = _ref2._ref,
      className = _ref2.className,
      wrapperClassName = _ref2.wrapperClassName;
  return (
    /*#__PURE__*/
    React.createElement("section", {
      style: _objectSpread({}, styles.wrapper, {
        width: width,
        height: height
      }),
      className: wrapperClassName
    }, !isEditorReady &&
    /*#__PURE__*/
    React.createElement(Loading, {
      content: loading
    }),
    /*#__PURE__*/
    React.createElement("div", {
      ref: _ref,
      style: _objectSpread({}, styles.fullWidth, !isEditorReady && styles.hide),
      className: className
    }))
  );
}

MonacoContainer.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  loading: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  isEditorReady: PropTypes.bool.isRequired,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string
};
export default MonacoContainer;